import type { EditorHandle } from './Editor';
import type { FormatAction } from '../editor/format';
import { Icon } from './Icon';
import type { IconName } from './Icon';

interface Btn {
  action: FormatAction | 'table';
  icon: IconName;
  title: string;
}

const GROUPS: Btn[][] = [
  [
    { action: 'h1', icon: 'heading-1', title: 'Heading 1' },
    { action: 'h2', icon: 'heading-2', title: 'Heading 2' },
    { action: 'h3', icon: 'heading-3', title: 'Heading 3' },
  ],
  [
    { action: 'bold', icon: 'bold', title: 'Bold (Cmd/Ctrl+B)' },
    { action: 'italic', icon: 'italic', title: 'Italic (Cmd/Ctrl+I)' },
    { action: 'strike', icon: 'strikethrough', title: 'Strikethrough' },
    { action: 'code', icon: 'code', title: 'Inline code (Cmd/Ctrl+E)' },
  ],
  [
    { action: 'link', icon: 'link', title: 'Link' },
    { action: 'quote', icon: 'quote', title: 'Blockquote' },
    { action: 'codeblock', icon: 'braces', title: 'Code block' },
    { action: 'table', icon: 'table', title: 'Table' },
  ],
  [
    { action: 'ul', icon: 'list', title: 'Bulleted list' },
    { action: 'ol', icon: 'list-ordered', title: 'Numbered list' },
    { action: 'task', icon: 'list-checks', title: 'Task list' },
  ],
];

/** A slim Markdown formatting toolbar that acts on the editor selection. */
export function FormatBar({ editorRef }: { editorRef: React.RefObject<EditorHandle> }) {
  const run = (action: Btn['action']) =>
    action === 'table' ? editorRef.current?.table('insert') : editorRef.current?.format(action);

  return (
    <div className="mb-formatbar" role="toolbar" aria-label="Formatting">
      {GROUPS.map((group, gi) => (
        <div className="mb-formatbar-group" key={gi}>
          {group.map((b) => (
            <button
              key={b.action}
              className="mb-fmt-btn"
              title={b.title}
              aria-label={b.title}
              // Keep the editor selection: prevent the button from stealing focus.
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => run(b.action)}
            >
              <Icon name={b.icon} size={17} />
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
